import axios, { AxiosResponse } from 'axios';

export const getBaseUrl = (unityUrl?: boolean) => {
    return unityUrl ? process.env.UNITY_BACKEND_HOST : process.env.BACKEND_HOST;
};

export const getUnityBaseUrl = () => {
    return process.env.UNITY_BACKEND_HOST;
};

export const api = {
    get: <T>(url: string, params?: object, unityUrl?: boolean) =>
        axios.get<T>(url, {
            baseURL: getBaseUrl(unityUrl),
            ...params,
        }),
    post: <T, K>(url: string, data: T, params?: object, unityUrl?: boolean) =>
        axios.post<T, AxiosResponse<K>>(url, data, {
            baseURL: getBaseUrl(unityUrl),
            ...params,
        }),
    patch: <T>(url: string, data: T) =>
        axios.patch<T>(url, data, {
            baseURL: getBaseUrl(),
        }),
    put: <T>(url: string, data: T, params?: object) =>
        axios.put<T>(url, data, {
            baseURL: getBaseUrl(),
            ...params,
        }),
    delete: <T>(url: string, params?: object) =>
        axios.delete<T>(url, {
            baseURL: getBaseUrl(),
            ...params,
        }),
};
